import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-final-it-facility-rejgrid',
  templateUrl: './final-it-facility-rejgrid.component.html',
  styleUrls: ['./final-it-facility-rejgrid.component.scss']
})
export class FinalItFacilityRejgridComponent implements OnInit {

  
  constructor(public appservice:AppService,public router:Router) { }
  verifyemployee(id:any){
    this.appservice.FinalItfacilityeditdata=id;
    this.router.navigate(['/home/final-itfacility-rejform']);
  }

  ngOnInit(): void {
    this.appservice.FinalitFacilityGrid();
  }

}
